import { render, staticRenderFns } from "./LiabilityLoanFull.vue?vue&type=template&id=5671ef4f"
import script from "./LiabilityLoanFull.vue?vue&type=script&lang=js"
export * from "./LiabilityLoanFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports